"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelWithComponentsSchema = exports.ModelWithWarningsSchema = void 0;
const zod_1 = require("zod");
const component_1 = require("./component");
exports.ModelWithWarningsSchema = zod_1.z.object({
    warnings: zod_1.z.string().array(),
});
exports.ModelWithComponentsSchema = exports.ModelWithWarningsSchema.extend({
    components: zod_1.z.record(zod_1.z.string(), component_1.ComponentSchema),
});
//# sourceMappingURL=modelWithComponents.js.map